import { post } from '../index';

export const createDiscipline = data => {
  return post('/discipline', data);
};